import { useRouter } from "../../store/router";
import { useI18n } from "../../i18n/useI18n";
import { QRCode2D } from "./QRCode";
import { shareQrUrl } from "./shareQr";

/** store 의 세션 주소로 만든 QR 공유 주소 — 세션이 없으면 null (사진 받기 전·리셋 뒤) */
export function useShareQrUrl(): string | null {
  const downloadUrl = useRouter((s) => s.downloadUrl);
  const { language } = useI18n();
  return shareQrUrl(downloadUrl, language);
}

interface Props {
  /** QR 아래 한 줄 캡션. 화면이 이미 같은 안내를 하고 있으면 생략 */
  caption?: string;
}

/**
 * 인쇄 중·thanks 화면에 남기는 소형 QR (BOOTH-63) — "인쇄하기를 눌러도 다운로드 링크가 그대로 남아 있을 것".
 * 사진 받기 화면의 `.qr-box` 를 축소판(`.qr-box--small`)으로 재사용한다. 세션이 없으면 아무것도 그리지 않는다.
 */
export function ShareQrAside({ caption }: Props) {
  const url = useShareQrUrl();
  const { t } = useI18n();
  if (!url) return null;
  return (
    <div className="qr-aside">
      <div className="qr-box qr-box--small" role="img" aria-label={t.printShare.qrAlt}>
        <QRCode2D value={url} size={320} />
      </div>
      {caption ? <p className="qr-aside__caption">{caption}</p> : null}
    </div>
  );
}
